export class BaseComponent {

	ngAfterViewInit() {
		window.dispatchEvent(new Event('navigate'));
	}

}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/base.component.ts